// Legal documents for Casa de Candy
export const legalContent = {
  // CLIENT TERMS OF SERVICE
  clientTerms: {
    en: {
      title: "Client Terms of Service",
      lastUpdated: "January 2026",
      sections: [
        {
          title: "1. Nature of Services",
          content: "Casa de Candy operates legally as a companionship service. We provide time, environment, and presence within a curated experience. Our services consist solely of social companionship and the reservation of time with our companions. No other services are implied, offered, or provided."
        },
        {
          title: "2. Eligibility",
          content: "You must be at least 18 years of age to use our services. By accessing this website or engaging our services, you confirm that you are of legal age and have the legal capacity to enter into this agreement."
        },
        {
          title: "3. Requests & Scheduling",
          content: "All session requests are subject to availability. Submitting a request does not guarantee a confirmed appointment. We reserve the right to accept or decline any request at our sole discretion without providing a reason."
        },
        {
          title: "4. Compensation for Time Reserved",
          content: "Payment is made for the reservation of time and companionship only. Rates are clearly posted and must be agreed upon before any session. Payment is due at the beginning of each session unless otherwise arranged."
        },
        {
          title: "5. Cancellations",
          content: "We require at least 2 hours notice for any cancellations or rescheduling. Deposits for confirmed out-call appointments are non-refundable for no-shows or last-minute cancellations. Repeated cancellations may result in denial of future service."
        },
        {
          title: "6. Conduct & Boundaries",
          content: "Clients must conduct themselves respectfully at all times. Any form of harassment, aggression, or inappropriate behavior will result in immediate termination of the session without refund. Sobriety is required. Photography and recording are strictly prohibited."
        },
        {
          title: "7. Confidentiality",
          content: "We maintain strict confidentiality regarding client information. We expect the same discretion from our clients regarding our companions and operations. Any breach of confidentiality may result in permanent denial of service."
        },
        {
          title: "8. Limitation of Liability",
          content: "Casa de Candy, its owners, operators, and companions shall not be liable for any direct, indirect, incidental, consequential, or punitive damages arising from the use of our services. Our total liability shall not exceed the amount paid for the specific session in question."
        },
        {
          title: "9. Assumption of Risk",
          content: "By engaging our services, you acknowledge and accept any inherent risks associated with social companionship services. You agree to hold Casa de Candy harmless from any claims arising from your use of our services."
        },
        {
          title: "10. Refusal of Service",
          content: "Casa de Candy reserves the right to refuse service to anyone for any reason. This includes, but is not limited to, previous policy violations, inappropriate behavior, or safety concerns."
        },
        {
          title: "11. Governing Law",
          content: "These Terms of Service shall be governed by and construed in accordance with the laws of the State of Texas. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts in Texas."
        },
        {
          title: "12. Acceptance",
          content: "By checking the acknowledgment box and accessing our services, you confirm that you have read, understood, and agree to be bound by these Terms of Service."
        }
      ]
    },
    es: {
      title: "Términos de Servicio para Clientes",
      lastUpdated: "Enero 2026",
      sections: [
        {
          title: "1. Naturaleza de los Servicios",
          content: "Casa de Candy opera legalmente como un servicio de compañía. Proporcionamos tiempo, ambiente y presencia dentro de una experiencia curada. Nuestros servicios consisten únicamente en compañía social y la reserva de tiempo con nuestras compañeras. No se implican, ofrecen ni proporcionan otros servicios."
        },
        {
          title: "2. Elegibilidad",
          content: "Debes tener al menos 18 años de edad para usar nuestros servicios. Al acceder a este sitio web o contratar nuestros servicios, confirmas que eres mayor de edad legal y tienes la capacidad legal para celebrar este acuerdo."
        },
        {
          title: "3. Solicitudes y Programación",
          content: "Todas las solicitudes de sesión están sujetas a disponibilidad. Enviar una solicitud no garantiza una cita confirmada. Nos reservamos el derecho de aceptar o rechazar cualquier solicitud a nuestra sola discreción sin proporcionar una razón."
        },
        {
          title: "4. Compensación por Tiempo Reservado",
          content: "El pago se realiza únicamente por la reserva de tiempo y compañía. Las tarifas están claramente publicadas y deben acordarse antes de cualquier sesión. El pago se debe al inicio de cada sesión a menos que se acuerde lo contrario."
        },
        {
          title: "5. Cancelaciones",
          content: "Requerimos al menos 2 horas de aviso para cualquier cancelación o reprogramación. Los depósitos para citas a domicilio confirmadas no son reembolsables por ausencias o cancelaciones de último momento. Las cancelaciones repetidas pueden resultar en la negación de servicio futuro."
        },
        {
          title: "6. Conducta y Límites",
          content: "Los clientes deben comportarse con respeto en todo momento. Cualquier forma de acoso, agresión o comportamiento inapropiado resultará en la terminación inmediata de la sesión sin reembolso. Se requiere sobriedad. La fotografía y grabación están estrictamente prohibidas."
        },
        {
          title: "7. Confidencialidad",
          content: "Mantenemos estricta confidencialidad con respecto a la información del cliente. Esperamos la misma discreción de nuestros clientes con respecto a nuestras compañeras y operaciones. Cualquier violación de la confidencialidad puede resultar en la negación permanente de servicio."
        },
        {
          title: "8. Limitación de Responsabilidad",
          content: "Casa de Candy, sus propietarios, operadores y compañeras no serán responsables de ningún daño directo, indirecto, incidental, consecuente o punitivo que surja del uso de nuestros servicios. Nuestra responsabilidad total no excederá el monto pagado por la sesión específica en cuestión."
        },
        {
          title: "9. Asunción de Riesgo",
          content: "Al contratar nuestros servicios, reconoces y aceptas cualquier riesgo inherente asociado con los servicios de compañía social. Aceptas eximir a Casa de Candy de cualquier reclamo que surja de tu uso de nuestros servicios."
        },
        {
          title: "10. Negación de Servicio",
          content: "Casa de Candy se reserva el derecho de negar servicio a cualquier persona por cualquier motivo. Esto incluye, pero no se limita a, violaciones previas de políticas, comportamiento inapropiado o preocupaciones de seguridad."
        },
        {
          title: "11. Ley Aplicable",
          content: "Estos Términos de Servicio se regirán e interpretarán de acuerdo con las leyes del Estado de Texas. Cualquier disputa que surja de estos términos estará sujeta a la jurisdicción exclusiva de los tribunales de Texas."
        },
        {
          title: "12. Aceptación",
          content: "Al marcar la casilla de reconocimiento y acceder a nuestros servicios, confirmas que has leído, entendido y aceptas estar obligado por estos Términos de Servicio."
        }
      ]
    }
  },

  // CLIENT PRIVACY POLICY
  clientPrivacy: {
    en: {
      title: "Client Privacy Policy",
      lastUpdated: "January 2026",
      sections: [
        {
          title: "1. Information We Collect",
          content: "We may collect contact information (name, phone number, email), scheduling preferences, and session history. We collect only the minimum information necessary to provide our services."
        },
        {
          title: "2. Purpose of Use",
          content: "Your information is used solely for scheduling, communication regarding appointments, and improving our services. We do not use your information for marketing purposes without explicit consent."
        },
        {
          title: "3. No Sale of Data",
          content: "We do not sell, trade, or rent your personal information to third parties under any circumstances."
        },
        {
          title: "4. Confidentiality",
          content: "All client information is treated with the utmost confidentiality. Access to client data is strictly limited to essential personnel only."
        },
        {
          title: "5. Security Practices",
          content: "We implement reasonable security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction."
        },
        {
          title: "6. Legal Disclosure",
          content: "We may disclose your information only if required by law, court order, or governmental regulation. We will make reasonable efforts to notify you of such disclosure where legally permitted."
        },
        {
          title: "7. Your Rights",
          content: "You have the right to request access to, correction of, or deletion of your personal information. Contact us to exercise these rights."
        },
        {
          title: "8. Data Retention",
          content: "We retain your information only for as long as necessary to provide services and comply with legal obligations. Upon request, we will delete your information subject to legal requirements."
        }
      ]
    },
    es: {
      title: "Política de Privacidad para Clientes",
      lastUpdated: "Enero 2026",
      sections: [
        {
          title: "1. Información que Recopilamos",
          content: "Podemos recopilar información de contacto (nombre, número de teléfono, email), preferencias de programación e historial de sesiones. Recopilamos solo la información mínima necesaria para proporcionar nuestros servicios."
        },
        {
          title: "2. Propósito de Uso",
          content: "Tu información se utiliza únicamente para programación, comunicación sobre citas y mejorar nuestros servicios. No utilizamos tu información para fines de marketing sin consentimiento explícito."
        },
        {
          title: "3. No Venta de Datos",
          content: "No vendemos, intercambiamos ni alquilamos tu información personal a terceros bajo ninguna circunstancia."
        },
        {
          title: "4. Confidencialidad",
          content: "Toda la información del cliente se trata con la máxima confidencialidad. El acceso a los datos del cliente está estrictamente limitado al personal esencial únicamente."
        },
        {
          title: "5. Prácticas de Seguridad",
          content: "Implementamos medidas de seguridad razonables para proteger tu información personal contra acceso no autorizado, alteración, divulgación o destrucción."
        },
        {
          title: "6. Divulgación Legal",
          content: "Podemos divulgar tu información solo si lo requiere la ley, orden judicial o regulación gubernamental. Haremos esfuerzos razonables para notificarte de dicha divulgación cuando sea legalmente permitido."
        },
        {
          title: "7. Tus Derechos",
          content: "Tienes derecho a solicitar acceso, corrección o eliminación de tu información personal. Contáctanos para ejercer estos derechos."
        },
        {
          title: "8. Retención de Datos",
          content: "Retenemos tu información solo mientras sea necesario para proporcionar servicios y cumplir con obligaciones legales. A solicitud, eliminaremos tu información sujeto a requisitos legales."
        }
      ]
    }
  },

  // RECRUIT TERMS OF SERVICE
  recruitTerms: {
    en: {
      title: "Recruit Terms of Service",
      lastUpdated: "January 2026",
      sections: [
        {
          title: "1. Application Process",
          content: "Submitting an application to Casa de Candy does not guarantee engagement, employment, or any form of relationship. All applications are reviewed at our sole discretion, and we reserve the right to accept or decline any applicant without providing a reason."
        },
        {
          title: "2. Eligibility",
          content: "Applicants must be at least 18 years of age. By submitting an application, you confirm that you are of legal age and all information provided is accurate and truthful."
        },
        {
          title: "3. Confidentiality & NDA",
          content: "By applying, you agree to maintain strict confidentiality regarding all Casa de Candy operations, methods, client information, and internal communications. Violation of confidentiality may result in legal action."
        },
        {
          title: "4. Media & Information Restrictions",
          content: "You may not share, distribute, or publish any photos, videos, communications, or information related to Casa de Candy without explicit written permission. This includes social media posts, interviews, and any public statements."
        },
        {
          title: "5. Conduct & Professionalism",
          content: "All recruits must maintain the highest standards of professionalism, discretion, and brand integrity. This includes appearance, communication, punctuality, and conduct during all interactions."
        },
        {
          title: "6. Brand Integrity",
          content: "Recruits represent Casa de Candy and must uphold our brand values at all times. Any action that damages the reputation or integrity of Casa de Candy may result in immediate termination of the relationship."
        },
        {
          title: "7. Termination Rights",
          content: "Casa de Candy reserves the right to terminate any relationship with a recruit at any time, for any reason, with or without notice. Similarly, recruits may discontinue their association at any time."
        },
        {
          title: "8. No Employment Guarantee",
          content: "Association with Casa de Candy does not constitute employment. Recruits operate independently and are responsible for their own tax obligations and legal compliance."
        },
        {
          title: "9. Governing Law",
          content: "These Terms of Service shall be governed by and construed in accordance with the laws of the State of Texas. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts in Texas."
        }
      ]
    },
    es: {
      title: "Términos de Servicio para Reclutas",
      lastUpdated: "Enero 2026",
      sections: [
        {
          title: "1. Proceso de Aplicación",
          content: "Enviar una solicitud a Casa de Candy no garantiza compromiso, empleo ni ninguna forma de relación. Todas las solicitudes se revisan a nuestra sola discreción, y nos reservamos el derecho de aceptar o rechazar a cualquier solicitante sin proporcionar una razón."
        },
        {
          title: "2. Elegibilidad",
          content: "Los solicitantes deben tener al menos 18 años de edad. Al enviar una solicitud, confirmas que eres mayor de edad legal y que toda la información proporcionada es precisa y veraz."
        },
        {
          title: "3. Confidencialidad y NDA",
          content: "Al aplicar, aceptas mantener estricta confidencialidad con respecto a todas las operaciones, métodos, información de clientes y comunicaciones internas de Casa de Candy. La violación de la confidencialidad puede resultar en acción legal."
        },
        {
          title: "4. Restricciones de Medios e Información",
          content: "No puedes compartir, distribuir ni publicar fotos, videos, comunicaciones o información relacionada con Casa de Candy sin permiso escrito explícito. Esto incluye publicaciones en redes sociales, entrevistas y cualquier declaración pública."
        },
        {
          title: "5. Conducta y Profesionalismo",
          content: "Todos los reclutas deben mantener los más altos estándares de profesionalismo, discreción e integridad de marca. Esto incluye apariencia, comunicación, puntualidad y conducta durante todas las interacciones."
        },
        {
          title: "6. Integridad de Marca",
          content: "Los reclutas representan a Casa de Candy y deben mantener nuestros valores de marca en todo momento. Cualquier acción que dañe la reputación o integridad de Casa de Candy puede resultar en la terminación inmediata de la relación."
        },
        {
          title: "7. Derechos de Terminación",
          content: "Casa de Candy se reserva el derecho de terminar cualquier relación con un recluta en cualquier momento, por cualquier motivo, con o sin aviso. Del mismo modo, los reclutas pueden discontinuar su asociación en cualquier momento."
        },
        {
          title: "8. Sin Garantía de Empleo",
          content: "La asociación con Casa de Candy no constituye empleo. Los reclutas operan de forma independiente y son responsables de sus propias obligaciones fiscales y cumplimiento legal."
        },
        {
          title: "9. Ley Aplicable",
          content: "Estos Términos de Servicio se regirán e interpretarán de acuerdo con las leyes del Estado de Texas. Cualquier disputa que surja de estos términos estará sujeta a la jurisdicción exclusiva de los tribunales de Texas."
        }
      ]
    }
  },

  // RECRUIT PRIVACY POLICY
  recruitPrivacy: {
    en: {
      title: "Recruit Privacy Policy",
      lastUpdated: "January 2026",
      sections: [
        {
          title: "1. Application Data",
          content: "We collect information submitted in your application including name, contact information, photos, availability, experience, and any other details you provide."
        },
        {
          title: "2. Photo & Media Handling",
          content: "Photos and media submitted as part of your application are used solely for internal review and assessment purposes. They are stored securely and are not shared externally without your explicit consent."
        },
        {
          title: "3. Internal Review Use Only",
          content: "All application information is used exclusively for internal review, assessment, and communication regarding your application status. We do not use your information for any other purpose."
        },
        {
          title: "4. Retention & Deletion",
          content: "Application data is retained only for as long as necessary for review and potential engagement. Unsuccessful applications are deleted within 90 days unless you request earlier deletion. You may request deletion of your data at any time."
        },
        {
          title: "5. Confidentiality Obligations",
          content: "Access to recruit application data is strictly limited to authorized personnel involved in the review process. All personnel are bound by confidentiality obligations."
        },
        {
          title: "6. Security Measures",
          content: "We implement appropriate security measures to protect your application data from unauthorized access, alteration, or disclosure."
        },
        {
          title: "7. Your Rights",
          content: "You have the right to access, correct, or request deletion of your application data. Contact us to exercise these rights."
        }
      ]
    },
    es: {
      title: "Política de Privacidad para Reclutas",
      lastUpdated: "Enero 2026",
      sections: [
        {
          title: "1. Datos de Solicitud",
          content: "Recopilamos la información enviada en tu solicitud incluyendo nombre, información de contacto, fotos, disponibilidad, experiencia y cualquier otro detalle que proporciones."
        },
        {
          title: "2. Manejo de Fotos y Medios",
          content: "Las fotos y medios enviados como parte de tu solicitud se utilizan únicamente para revisión interna y propósitos de evaluación. Se almacenan de forma segura y no se comparten externamente sin tu consentimiento explícito."
        },
        {
          title: "3. Uso Solo para Revisión Interna",
          content: "Toda la información de la solicitud se utiliza exclusivamente para revisión interna, evaluación y comunicación sobre el estado de tu solicitud. No utilizamos tu información para ningún otro propósito."
        },
        {
          title: "4. Retención y Eliminación",
          content: "Los datos de la solicitud se retienen solo el tiempo necesario para la revisión y posible compromiso. Las solicitudes no exitosas se eliminan dentro de 90 días a menos que solicites una eliminación anterior. Puedes solicitar la eliminación de tus datos en cualquier momento."
        },
        {
          title: "5. Obligaciones de Confidencialidad",
          content: "El acceso a los datos de solicitud de reclutas está estrictamente limitado al personal autorizado involucrado en el proceso de revisión. Todo el personal está sujeto a obligaciones de confidencialidad."
        },
        {
          title: "6. Medidas de Seguridad",
          content: "Implementamos medidas de seguridad apropiadas para proteger los datos de tu solicitud contra acceso no autorizado, alteración o divulgación."
        },
        {
          title: "7. Tus Derechos",
          content: "Tienes derecho a acceder, corregir o solicitar la eliminación de los datos de tu solicitud. Contáctanos para ejercer estos derechos."
        }
      ]
    }
  }
};

export default legalContent;
